// Set up jQuery globally before anything else
import "./jquery-setup";

import {render} from "@variocube/app-ui";
import React from "react";
import {App} from "./app";

render(<App />);
